module.exports = __webpack_public_path__ + "static/media/EG.84e6cda7.png";